import React from 'react';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Label,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';
import { useTheme } from '@mui/material';
import { Conversion } from '../../@types/api';

type data = {
  month: string;
  thisYear: number;
  lastYear: number;
};

const createData = (month: string, thisYear: number, lastYear: number) => {
  return { month, thisYear, lastYear } as data;
};

const projectAllData = (data: Conversion[]) => {
  if (!data) return [];
  const arr: data[] = [];
  data.forEach((element) => {
    arr.push(
      createData(
        element.month.substring(0, 3),
        element.conversionRate,
        element.previousConversionRate
      )
    );
  });
  return arr;
};

interface Props {
  data: Conversion[];
}
const TurnoverRate: React.FC<Props> = ({ data }) => {
  const theme = useTheme();
  const chartData: data[] = projectAllData(data);
  return (
    <ResponsiveContainer width={'100%'} height={300}>
      <LineChart
        data={chartData}
        margin={{
          top: 16,
          right: 16,
          bottom: 40,
          left: 24,
        }}
      >
        <XAxis dataKey='month' stroke={theme.palette.primary.main} />
        <YAxis stroke={theme.palette.primary.main} dataKey='thisYear'>
          <Label
            angle={270}
            position='left'
            style={{ textAnchor: 'middle', fill: theme.palette.text.primary }}
          >
            Rate
          </Label>
        </YAxis>
        <Tooltip />
        <Legend />
        <Line
          type='monotone'
          dataKey='thisYear'
          stroke={theme.palette.primary.main}
        />
        <Line
          type='monotone'
          dataKey='lastYear'
          stroke={theme.palette.secondary.main}
        />
      </LineChart>
    </ResponsiveContainer>
  );
};

export default TurnoverRate;
